"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BaseOption = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("../constants");
var _styles = require("../styles");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const BaseOption = (param)=>{
    let { LabelProps: labelProps, onClick, color, label, icon, clickable, variant, height, selected, onDelete, value } = param;
    const { palette } = (0, _mui.useTheme)();
    const { getTestId } = (0, _testidGenerator.default)();
    const customLabel = typeof label === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles2.Label, {
        "data-testid": getTestId(_constants.BASE_OPTION_LABEL),
        component: "span",
        textTransform: "capitalize",
        color: selected ? palette.success.contrastText : palette.text.primary,
        ...labelProps,
        children: label
    }) : label;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.StyledBaseChip, {
        "data-testid": getTestId("".concat(selected ? _constants.BASE_OPTION_SELECTED : _constants.BASE_OPTION, "-").concat(value)),
        selected: selected,
        color: color,
        label: customLabel,
        icon: icon,
        height: height,
        clickable: clickable,
        variant: variant,
        onDelete: onDelete,
        onClick: onClick
    });
};
exports.BaseOption = BaseOption;
